import { RECENT_SEARCH_HELPER } from '../utils/recent-searches'
import { mapShopSearchRequest } from '../utils/flight-search-form-utils'
import { buildShopSearchForm } from '@pcln/home-components'

export default {
  searchRetail (request, isFlightsHomeSearch = false) {
    RECENT_SEARCH_HELPER.saveVPSearch(request)

    const formattedRequest = isFlightsHomeSearch
      ? mapShopSearchRequest(request)
      : request

    const form = buildShopSearchForm(
      '/shop/search/',
      formattedRequest
    )

    form.submit()
  }
}
